import { Col, Typography, Layout, Space, Button } from "antd";
import { PlusOutlined, ReloadOutlined, AppstoreAddOutlined } from "@ant-design/icons";
import Header160 from "../../header/header";
const { Title, Text } = Typography;
export default function ProductosHeader({ onCreate, onBulkCreate, onRefresh, permissionInsert }) {
  return (
    <div className="container" style={{ paddingBottom: 20 }}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between">
          <Header160 /> 
          <Col flex="auto" style={{ textAlign: "center" }}>
            <Space direction="vertical" size={0} align="center">
              <Title
                level={3}
                style={{
                  margin: 0,
                  color: "#042956",
                  fontWeight: 600
                }}
              >
                Productos Financieros
              </Title>
              <Text
                style={{
                  color: "#6b7280",
                  fontSize: 14
                }}
              >
                Gestión y registro de inventario financiero
              </Text>
              <Space style={{ marginTop: 10 }}>
                {permissionInsert && (
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={onCreate}
                  >
                    Nuevo Producto
                  </Button>
                )}

                {permissionInsert && (
                  <Button
                    icon={<AppstoreAddOutlined />}
                    onClick={onBulkCreate}
                  >
                    Registro múltiple
                  </Button>
                )}
                <Button
                  icon={<ReloadOutlined />}
                  onClick={onRefresh}
                >
                  Refrescar
                </Button>
              </Space>
            </Space>
          </Col>
        </div>
      </Layout>
    </div>
  );
}